import { createTextFilterContext } from "@/components/TextFilter/createTextFilterContext";

export const dailyOverviewTextFilter = createTextFilterContext();

export const usePatientNameFilter = dailyOverviewTextFilter.useFilter;
export const usePatientNameFilterActions =
  dailyOverviewTextFilter.useFilterActions;
export const useDailyOverviewFilterBannerItem =
  dailyOverviewTextFilter.useFilterBannerItem;
